import { render, staticRenderFns } from "./marshals.vue?vue&type=template&id=2e20240c&scoped=true&"
import script from "./marshals.vue?vue&type=script&lang=js&"
export * from "./marshals.vue?vue&type=script&lang=js&"
import style0 from "./marshals.vue?vue&type=style&index=0&id=2e20240c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20240c",
  null
  
)

component.options.__file = "marshals.vue"
export default component.exports